<ng-container *transloco="let t; read: 'layout-dialog'">
  <div class="container">
    <div class="header">
      <div class="title">
        <div>
          <h1>{{ dialogTitle }}</h1>

          @if (learnId) {
            <div>
              <button mat-button class="button-learn" (click)="openLearnArticle()">
                <mat-icon [svgIcon]="Icons.Education"></mat-icon>
                {{ t('Learn') }}
              </button>
            </div>
          }
        </div>
        <button mat-icon-button color="accent" (click)="closeDialog.emit()">
          <mat-icon [svgIcon]="Icons.Close"></mat-icon>
        </button>
      </div>
      @if (showBreadcrumb) {
        <div class="breadcrumbs-container">
          <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
            <ng-content select="[dialogBreadcrumbs]"></ng-content>
          </mat-toolbar>
        </div>
      }
    </div>

    <div class="body">
      <ng-content select="[dialogBody]"></ng-content>
    </div>

    @if (showFooter) {
      <div class="footer">
        <ng-content select="[dialogFooter]"></ng-content>
      </div>
    }
  </div>
</ng-container>
